import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, GroupLineIcon, Space, useGetFormatMembersCount } from 'ui';
import { useTransactionItemsInfiniteQuery } from 'features/transactions';
import { DonationsModal } from './donations-modal';
import { RecentDonations } from './recent-donations';
import { DonationsSkeleton } from './skeletons';
import { TopDonors } from './top-donors';

type P = {
  givingId: string;
};

const Donations = ({ givingId }: P) => {
  const { t } = useTranslation();
  const getFormatMembersCount = useGetFormatMembersCount();
  const [isDonationsModalOpen, setIsDonationsModalOpen] = useState(false);

  const { data: recentDonationsData, isLoading } = useTransactionItemsInfiniteQuery({
    filter: { order: 'created_at', subjectId: givingId, subjectType: 'Giving' },
    pagination: { pageSize: 10 },
  });

  const recentDonationsPayment = recentDonationsData?.pages[0]?.data;
  const recentDonationsPaymentCount = recentDonationsData?.pages[0]?.total ?? 0;
  const title = t('Donations {{participants}}', {
    participants: getFormatMembersCount({ count: recentDonationsPaymentCount }),
  });

  return (
    <>
      {isLoading ? (
        <DonationsSkeleton />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      recentDonationsPayment?.length ? (
        <>
          <Card
            extra={
              recentDonationsPaymentCount > 10 ? (
                <Button
                  onClick={() => {
                    setIsDonationsModalOpen(true);
                  }}
                  type="link-primary"
                >
                  See all
                </Button>
              ) : null
            }
            title={<Card.Title icon={<GroupLineIcon />}>{title}</Card.Title>}
          >
            <Space block orientation="vertical" size="middle">
              <TopDonors givingId={givingId} />
              <RecentDonations recentDonationsPayment={recentDonationsPayment} />
            </Space>
          </Card>
          <DonationsModal
            givingId={givingId}
            isOpened={isDonationsModalOpen}
            onClose={() => {
              setIsDonationsModalOpen(false);
            }}
            title={title}
          />
        </>
      ) : null}
    </>
  );
};

export default Donations;
